import * as angular from 'angular';

const fdPreviewHtml = require('../../views/fd_preview.html');

'use strict';

angular.module('formApp').directive('fdPreview', function () {
  return {
    scope: {
      models: '='
    },
    templateUrl: fdPreviewHtml,
    replace: true,
    controller: 'fdPreviewCtrl'
  };
});
